var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/badge-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7878 8.26694C15.2026 8.15405 16.5456 7.59772 17.6259 6.67718C20.1466 4.52899 23.8542 4.52899 26.3749 6.67718C27.4551 7.59772 28.7982 8.15405 30.213 8.26694C33.5144 8.5304 36.136 11.152 36.3995 14.4535C36.5124 15.8682 37.0687 17.2113 37.9893 18.2915C40.1374 20.8123 40.1374 24.5198 37.9893 27.0406C37.0687 28.1208 36.5124 29.4639 36.3995 30.8786C36.136 34.1801 33.5144 36.8017 30.213 37.0651C28.7982 37.178 27.4551 37.7344 26.3749 38.6549C23.8542 40.8031 20.1466 40.8031 17.6259 38.6549C16.5456 37.7344 15.2026 37.178 13.7878 37.0651C10.4864 36.8017 7.86475 34.1801 7.60129 30.8786C7.4884 29.4639 6.93208 28.1208 6.01153 27.0406C3.86334 24.5198 3.86334 20.8123 6.01153 18.2915C6.93208 17.2113 7.4884 15.8682 7.60129 14.4535C7.86475 11.152 10.4864 8.5304 13.7878 8.26694ZM30.156 19.8217C31.0152 18.9625 31.0152 17.5696 30.156 16.7104C29.2969 15.8513 27.9039 15.8513 27.0448 16.7104L19.8004 23.9548L16.956 21.1104C16.0969 20.2512 14.7039 20.2512 13.8448 21.1104C12.9856 21.9696 12.9856 23.3625 13.8448 24.2217L18.2448 28.6217C19.1039 29.4808 20.4969 29.4808 21.356 28.6217L30.156 19.8217Z",
    fill: "#00760C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeCheck);
export default __webpack_public_path__ + "static/media/badge-check.52cd735c0bff0273e6ad30152d14f792.svg";
export { ForwardRef as ReactComponent };